// src/Components/Modules/Inventory/WorkOrders.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import { Box, Typography, Paper, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem, TextField, Chip } from '@mui/material';
import { FaPlus, FaCheckCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';

export default function WorkOrders() {
    const [orders, setOrders] = useState([]);
    const [boms, setBoms] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [form, setForm] = useState({ bom_id: '', production_quantity: 1, planned_date: new Date().toISOString().split('T')[0] });

    const fetchData = async () => {
        const [oRes, bRes] = await Promise.all([AxiosAuthInstance.get('manufacturing/work-orders'), AxiosAuthInstance.get('manufacturing/boms')]);
        setOrders(oRes.data.orders || []);
        setBoms(bRes.data.boms || []);
    };
    useEffect(() => { fetchData(); }, []);

    const handleCreate = async () => {
        try {
            await AxiosAuthInstance.post('manufacturing/work-orders', form);
            Swal.fire({ icon: 'success', title: 'Work Order Created!', timer: 1500, showConfirmButton: false });
            setDialogOpen(false);
            fetchData();
        } catch (err) { Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed' }); }
    };

    const handleComplete = async (id) => {
        const res = await Swal.fire({ title: 'Complete Production?', text: 'This will deduct raw materials and add finished goods to stock.', icon: 'warning', showCancelButton: true });
        if (res.isConfirmed) {
            try {
                await AxiosAuthInstance.post(`manufacturing/work-orders/${id}/complete`);
                Swal.fire({ icon: 'success', title: 'Production Completed & Stock Updated!', timer: 2000 });
                fetchData();
            } catch (err) { Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.error || 'Failed (Check Stock)' }); }
        }
    };

    const statusColor = { pending: 'warning', in_progress: 'info', completed: 'success', cancelled: 'error' };

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Work Orders" />
            <Paper sx={{ p: 3, mb: 3, display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h5" fontWeight={700}>Production Work Orders</Typography>
                <Button variant="contained" startIcon={<FaPlus />} onClick={() => setDialogOpen(true)}>New Work Order</Button>
            </Paper>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead><TableRow sx={{ bgcolor: '#f8f9fa' }}><TableCell>WO Number</TableCell><TableCell>BOM / Product</TableCell><TableCell>Qty to Produce</TableCell><TableCell>Date</TableCell><TableCell>Status</TableCell><TableCell align="center">Action</TableCell></TableRow></TableHead>
                    <TableBody>
                        {orders.map(o => (
                            <TableRow key={o.id} hover>
                                <TableCell><code>{o.work_order_number}</code></TableCell>
                                <TableCell>{o.bom?.bom_name} ➔ {o.bom?.finished_item?.name}</TableCell>
                                <TableCell>{o.production_quantity}</TableCell>
                                <TableCell>{o.planned_date}</TableCell>
                                <TableCell><Chip label={o.status} size="small" color={statusColor[o.status]} /></TableCell>
                                <TableCell align="center">
                                    {o.status !== 'completed' && (
                                        <Button size="small" variant="outlined" color="success" startIcon={<FaCheckCircle />} onClick={() => handleComplete(o.id)}>Complete</Button>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Create Work Order</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <FormControl fullWidth size="small"><InputLabel>Select BOM (Recipe)</InputLabel>
                            <Select value={form.bom_id} label="Select BOM" onChange={e => setForm({...form, bom_id: e.target.value})}>
                                {boms.map(b => <MenuItem key={b.id} value={b.id}>{b.bom_name} (Yields: {b.produced_quantity} {b.finished_item?.name})</MenuItem>)}
                            </Select>
                        </FormControl>
                        <TextField label="Quantity to Produce" type="number" size="small" value={form.production_quantity} onChange={e => setForm({...form, production_quantity: e.target.value})} fullWidth />
                        <TextField label="Planned Date" type="date" size="small" value={form.planned_date} onChange={e => setForm({...form, planned_date: e.target.value})} InputLabelProps={{shrink: true}} fullWidth />
                    </Box>
                </DialogContent>
                <DialogActions><Button onClick={() => setDialogOpen(false)}>Cancel</Button><Button variant="contained" onClick={handleCreate}>Create Order</Button></DialogActions>
            </Dialog>
        </Box>
    );
}